import QueryParams from '~/services/QueryParams';
import sessionStorage from '~/services/storage/sessionStorage';

const UTM_KEY = 'utm_medium';
const SESSION_STORAGE_KEY = 'source';
const EMAIL_ANALYTICS_KEY = 'email';

type Source = 'email' | 'pwa' | 'web';

export const getSource = (): Source => {
  const sourceFromStorage = sessionStorage.getByKey(
    SESSION_STORAGE_KEY,
  ) as Source;
  const sourceFromQueryParams = QueryParams.getQueryParam(UTM_KEY);

  if (sourceFromQueryParams === EMAIL_ANALYTICS_KEY) {
    return sourceFromQueryParams;
  } else if (sourceFromStorage) {
    return sourceFromStorage;
  } else {
    return 'web';
  }
};

export const saveSource = (source: Source): void => {
  sessionStorage.setByKey(SESSION_STORAGE_KEY, source);
};
